import { MachineGuards } from 'common/bento/types/MachineConfig';
import getApplicationTypeFromCompany from 'features/Onboarding/common/getApplicationType';
import { getApplicationType as getApplicationTypeFromStorage } from 'features/Onboarding/common/localStorage/applicationType';
import canEditPersonalInformation from 'features/Onboarding/lib/canEditPersonalInformation';
import logger from 'helpers/logger';

import { FRANCE_COUNTRY_CODE } from '../../../../Bento/libs/constants';
import { Model } from './model';

export enum Guard {
  CanEditComplianceInformation = 'canEditComplianceInformation',
  IsForeignTaxResidencyNotAllowed = 'isForeignTaxResidencyNotAllowed',
  IsMissingFiscalId = 'isMissingFiscalId',
  IsNotEligibleToOnboard = 'isNotEligibleToOnboard',
  IsSpecifiedUSPerson = 'isSpecifiedUSPerson',
}

const guards: MachineGuards<Model, Guard> = {
  canEditComplianceInformation: ({ getModuleData }) => {
    const { companyUser, companyUsers, isNewOnboardingAllowed } =
      getModuleData().viewer;

    return canEditPersonalInformation({
      companyUser: companyUser || null,
      companyUsers: companyUsers || null,
      isNewOnboardingAllowed,
    });
  },
  isForeignTaxResidencyNotAllowed: ({ getModuleData }) => {
    const { isCapitalDeposit, isShineStart } =
      getModuleData().viewer.company || {};

    const hasForeignTaxResidency = !!getModuleData().viewer.taxResidencies.find(
      ({ country }) => country !== FRANCE_COUNTRY_CODE,
    );

    if (!hasForeignTaxResidency) {
      return false;
    }

    const applicationTypeFromCompany = getApplicationTypeFromCompany({
      isCapitalDeposit,
      isShineStart,
    });

    const applicationTypeFromStorage = getApplicationTypeFromStorage();

    if (
      applicationTypeFromCompany &&
      applicationTypeFromStorage &&
      applicationTypeFromCompany !== applicationTypeFromStorage
    ) {
      logger.error('applicationType from company differs from storage', {
        context: {
          applicationTypeFromCompany,
          applicationTypeFromStorage,
        },
      });
    }

    const isStandard =
      applicationTypeFromCompany === 'standard' ||
      applicationTypeFromStorage === 'standard';

    return !isStandard;
  },

  isMissingFiscalId: ({ getModuleData }) => {
    const foreignTaxResidencies = getModuleData().viewer.taxResidencies.filter(
      ({ country }) => country !== FRANCE_COUNTRY_CODE,
    );

    return foreignTaxResidencies.some((taxResidency) => !taxResidency.fiscalId);
  },
  isNotEligibleToOnboard: ({ getModuleData }) => {
    return !getModuleData().viewer.profile.isEligibleToOnboard;
  },
  isSpecifiedUSPerson: ({ getModuleData }) => {
    return getModuleData().viewer.profile.isSpecifiedUSPerson === true;
  },
};

export default guards;
